<template>
  <teleport to="#modals">
    <div class="modal is-fixed" :class="{ 'is-active': active }">
      <div class="modal-background" @click="this.closeModal()"></div>
      <div class="modal-content has-background-white p-4 container">
        <img
          src="../assets/img/close.svg"
          class="is-pulled-right close-button"
          @click="this.closeModal()"
        />
        <div class="is-clearfix"></div>
        <div class="video-container">
          <video-player v-if="activeVideo" :options="videoOptions"/>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import VideoPlayer from "../components/VideoPlayer";

export default {
  name: "VideoModal",
  components: {
    VideoPlayer
  },
  data() {
    return {
      active: false,
      activeVideo: false,
      videoOptions: {
        fluid: true,
        autoplay: false,
        controls: true,
        sources: []
      }          
    };
  },
  methods: {
    closeModal() {
      this.activeVideo = false;
      this.videoOptions.sources = []
      this.active = false;
    },
    showModal(videoUrl) {
      this.active = true;
      this.videoOptions.sources.push(
        {
          src: videoUrl,
          type: 'video/mp4'
        }
      ),
      this.activeVideo = true;
    },
  },
};
</script>

<style scoped lang="scss">
@use "../assets/sass/mybulma" as *;
.modal {
  .modal-content {
    background-color: $pale-yellow !important;
  }
  .close-button {
    cursor: pointer;
  }
}
h1 {
  font-size: 45pt;
  color: black;
}
p {
  font-size: 18pt;
}

.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-js {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.close-button {
  z-index: 2000;
  position: absolute;
  right: 10px;
}
</style>
